import { ErrorBoundary } from "@sentry/react";
import type { FallbackRender } from "@sentry/react";

export const SentryErrorBoundary = ErrorBoundary;
export type SentryFallbackRender = FallbackRender;
